module.exports = __webpack_public_path__ + "img/icon-star-red.0e4ff47d.svg";